import { render, staticRenderFns } from "./LocalPatientList.vue?vue&type=template&id=4a82c27d&"
import script from "./LocalPatientList.vue?vue&type=script&lang=js&"
export * from "./LocalPatientList.vue?vue&type=script&lang=js&"
import style0 from "./LocalPatientList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBanner,VBtn,VContainer,VLayout,VSnackbar})
